// Engine
import intakeDiagram from "../assets/images/19vxhoIntake1.jpg";
import engineDiagram from "../assets/images/engine-diagram.png";

// Electrical
import electricalDiagram from "../assets/images/electrical-diagram.png";

// Hull
import hullDiagram from "../assets/images/hull-diagram.png";

export const diagramMap = {
  "2019 Yamaha VX Cruiser HO": {
    Engine: {
      "Cylinder Head": engineDiagram,
      "Crankcase": engineDiagram,
      "Crankshaft": engineDiagram,
      "Intake": intakeDiagram,
      "Exhaust": engineDiagram,
      "Cooling": engineDiagram,
      "Gaskets": engineDiagram,
      "Motor Mounts": engineDiagram
    },

    Electrical: {
      "Main": electricalDiagram,
      "Ignition": electricalDiagram,
      "Charging": electricalDiagram
    },

    Hull: {
      "Body": hullDiagram,
      "Gunwale Mat": hullDiagram,
      "Side Covers": hullDiagram,
      "Front Cover / Hood": hullDiagram,
      "Ventilation System": hullDiagram
    },

    Oil: {
      "Oil Pump": engineDiagram,
      "Oil Cooler": engineDiagram,
      "Oil Pan": engineDiagram
    }
  }
};